export var _baseFileUploadTheme = {
  baseStyle: {
    outerContainer: {},
    innerContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      borderRadius: 'l',
      height: '100%',
      width: '100%',
      border: 'input-dashed.disabled',
      gap: 's',
      padding: 's',
      cursor: 'pointer',
      transition: 'color 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, outline-color 0.2s',
      color: 'neutral.darker',
      outline: 'transparent solid 2px',
      _hover: {
        color: 'neutral.darkest'
      },
      _active: {
        color: 'neutral.black'
      },
      _readOnly: {
        pointerEvents: 'none',
        cursor: 'default',
        color: 'neutral.light'
      },
      _invalid: {
        border: 'input-dashed.error'
      },
      _disabled: {
        cursor: 'not-allowed',
        color: 'neutral.light'
      },
      _focusVisible: {
        outlineColor: 'focus.focus',
        outlineOffset: '2px'
      },
      _selected: {
        justifyContent: 'space-between',
        pointerEvents: 'all',
        gap: 'none',
        _invalid: {
          border: 'input-dashed.error'
        }
      },
      '&[data-loading="true"]': {
        justifyContent: 'center',
        cursor: 'progress'
      }
    },
    placeholder: {
      display: 'flex',
      gap: 's'
    },
    placeholderLabel: {
      _readOnly: {
        color: 'neutral.darkest'
      }
    },
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'row'
    },
    label: {
      textStyle: 'body2',
      textDecorationLine: 'underline',
      cursor: 'pointer',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: 'link.rest',
      _focusVisible: {
        outlineColor: 'focus.focus',
        transition: 'outline-color 0.2s'
      },
      _disabled: {
        cursor: 'not-allowed',
        color: 'neutral.light',
        _focus: {
          outline: 'none',
          boxShadow: 0
        },
        _hover: {
          color: 'neutral.light'
        }
      },
      _hover: {
        color: 'link.hover'
      },
      _pressed: {
        color: 'link.pressed'
      }
    }
  },
  sizes: {
    small: {
      placeholderLabel: {
        color: 'neutral.darker',
        textStyle: 'body2',
        _disabled: {
          color: 'neutral.light'
        }
      },
      placeholder: {
        flexDirection: 'row'
      },
      buttonsContainer: {
        marginLeft: 's',
        gap: 's'
      }
    },
    large: _ref => {
      var {
        value
      } = _ref;
      return {
        outerContainer: {
          gap: 's',
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        },
        placeholderLabel: {
          textStyle: 'body4',
          textAlign: 'center',
          color: 'neutral.darker',
          _disabled: {
            color: 'neutral.light'
          }
        },
        placeholder: {
          flexDirection: 'column',
          alignItems: 'center'
        },
        buttonsContainer: {
          gap: 'l',
          justifyContent: 'center'
        },
        innerContainer: {
          justifyContent: 'center',
          border: 'input-dashed-thick.disabled',
          _invalid: {
            border: 'input-dashed-thick.error'
          },
          _selected: {
            justifyContent: 'center'
          },
          _disabled: {
            opacity: value ? 0.35 : 1
          }
        }
      };
    }
  },
  defaultProps: {
    size: 'small'
  }
};
//# sourceMappingURL=_BaseFileUpload.theme.js.map